import { isNotNull } from '@grupoboticario/barril-del-chavo'
import { useIsMobile } from '@grupoboticario/flora-react'
import { useMemo } from 'react'
import { ShopWindowItem } from '../ShopWindow'
import { useCycle, useDynamicShowcases, useResellerContext } from 'src/hooks'
import { ResellerContextProps } from '../ResellerProvider'
import { transformToShopWindowDisplayProps } from '../ShopWindow/utils'

const MAX_SHOP_WINDOW_ITEMS = 12

export type HomeMainShowcaseProps = {
  catalogSlug?: string
}
export const HomeMainShowcase = ({ catalogSlug }: HomeMainShowcaseProps) => {
  const { reseller } = useResellerContext() as ResellerContextProps
  const cycle = useCycle()
  const isMobile = useIsMobile()

  const mainShowCasesResults = useDynamicShowcases({
    showcasesComponentName: 'VitrineMinhaLojaDigitalVitrineDestaque',
    maxItemsPerShowcase: MAX_SHOP_WINDOW_ITEMS,
  })

  const shopWindow = useMemo(() => {
    return mainShowCasesResults
      .map((mainShowCasesResult) =>
        transformToShopWindowDisplayProps(mainShowCasesResult, catalogSlug),
      )
      .filter(isNotNull)
  }, [mainShowCasesResults, reseller])

  if (!shopWindow.length) {
    return null
  }

  return (
    <>
      {shopWindow.map((item) =>
        item.isLoading || (!!item.products && item.products.length > 1) ? (
          <ShopWindowItem
            key={item.shopWindowType}
            shopWidth={'100%'}
            shopWindowType={item.shopWindowType}
            isMobile={isMobile}
            products={item.products}
            isLoading={item.isLoading}
            title={item.title}
            seeAllLink={item.seeAllLink}
            cycle={cycle.cycle?.cycle}
            banners={item.banners}
          />
        ) : null,
      )}
    </>
  )
}
